import React from 'react';
import { Avatar, Box, Button, Typography } from '@mui/material';
import Currency from 'react-currency-format';
import PesoIcon from '../../../../../../../assets/images/state/peso_icon.png';
import PinIcon from '../../../../../../../assets/images/state/pin_icon.png';

export const Data = ({ preview, p, handlerView}) => {
    const t = preview.data
    return (
        <Box pb={1}
            // border={"solid 1px"}
            width={{
                xs: '100%',
                // sm: '48%', md: '32%'
            }}
            height="auto"
            boxShadow="0px 4px 8px rgba(0, 0, 0, 0.1)"
            borderRadius="12px"
            overflow="hidden"
        >
            <Box height="5rem"/*height={isSmallScreen ? 65 : 100} width="100%" display="flex" alignItems="center" justifyContent="center"*/>
                <Avatar variant="rounded" src={p.coverPhoto.object} alt="property-cover"
                    sx={{ width: '100%', height: '100%', borderRadius: '12px 12px 0 0', objectFit: 'cover', }}
                />
            </Box>
            <Box height="100%" width="100%" p={1}/* pt={isSmallScreen && 1} pb={!isSmallScreen && 1} */display="flex" flexDirection="column" gap={0.7} bgcolor="#F9F9F9" borderRadius="0 0 12px 12px">
                <Typography variant="body1" fontWeight={550} lineHeight="13px" sx={{ fontSize: 10 }}>
                    {p.title.value}
                </Typography>
                <Box display="flex" alignItems="center" gap={0.5}>
                    <img src={PinIcon} alt="pin-icon" width={18} height={18} />
                    <Typography variant="body2" color="text.secondary" noWrap fontWeight={500} fontSize={11} sx={{ textTransform: 'uppercase' }}>
                        {p.location.city}{", "}{p.location.province}
                    </Typography>
                </Box>
                <Typography variant="body2" color="text.secondary" sx={{ fontSize: 10, overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', wordBreak: 'break-word', }}>
                    {p.description.value}
                </Typography>
                <Box display="flex" alignItems="center" gap={1}>
                    <Box fontSize={10} lineHeight="15px" fontWeight={500}>
                        Price start at
                    </Box>
                    <Box display="flex" alignItems="center" gap="1px" fontSize="1rem" lineHeight="16px" color="#FF8C00">
                        <img src={PesoIcon} alt="peso-icon" width={15} height={15} />
                        <Box display="flex" alignItems="center">
                            <Currency value={p.price.value} displayType="text" thousandSeparator />
                        </Box>
                    </Box>
                </Box>
                <Button onClick={() => handlerView(p.id)}
                    variant="contained"
                    size="small"
                    fullWidth
                    sx={{
                        // fontSize: 11,
                        //height: isSmallScreen  && 18,
                        fontSize: 11,
                        textTransform: 'none',
                        bgcolor: t.site_btns.bg || '#215D95',
                        ':hover': { bgcolor: t.site_btns.bg },
                    }}
                >
                    View
                </Button>
            </Box>
        </Box>

    );
};